
const getDefaultState = () => {
  return {
    cache_data_list: new Map(),
    cache_often_list: [],
    cache_list: [],
    max_cache: 5
  }
}

const storeData = function (need_store_props, target) {
  const need_store_obj = {}

  need_store_props.forEach((prop) => {
    need_store_obj[prop] = target[prop]
  })

  return need_store_obj
}

const state = getDefaultState()

const mutations = {
  RESET_ALL_LIST (state) {
    Object.assign(state, getDefaultState())
  },
  SET_CACHE_DATA_LIST (state, cache_data_list) {
    state.cache_data_list = cache_data_list
  },
  SET_CACHE_OFTEN_LIST (state, cache_often_list) {
    state.cache_often_list = cache_often_list
  },
  SET_CACHE_LIST (state, cache_list) {
    state.cache_list = cache_list
  }
}

const actions = {
  // 获取 缓存数据
  getCacheData ({ commit, state }, pageName) {
    const cache_data_list = state.cache_data_list

    const cache_often_list = state.cache_often_list

    // const cache_data_list = state.cache_data_list;

    let cache_list = state.cache_list

    const existIndex = cache_often_list.findIndex((each_cache) => (each_cache.name === pageName))

    let outer_data = {}

    let outer_props = []

    if (existIndex > -1) {
      outer_data = cache_data_list.get(pageName)
      outer_props = cache_often_list[existIndex].props

      cache_often_list[existIndex].visit_no++
    } else {
      cache_often_list.push({
        name: pageName,
        // props: [],
        visit_no: 1
      })
      cache_data_list.set(pageName, { data: null, props: [] })

      outer_data = null
      outer_props = []
    }

    cache_often_list.sort((a, b) => a.visit_no - b.visit_no)

    if (cache_often_list.length > state.max_cache) {
      let len = cache_often_list.length, i
      for (i = 0; i < len; i++) {
        const cur_need_del_name = cache_often_list[i].name
        if (cur_need_del_name !== pageName) {
          cache_often_list.splice(i, 1)
          cache_data_list.delete(cur_need_del_name)
          break
        }
      }
    }

    cache_list = cache_often_list.map((each_often) => each_often.name)

    commit('SET_CACHE_DATA_LIST', cache_data_list)
    commit('SET_CACHE_OFTEN_LIST', cache_often_list)
    commit('SET_CACHE_LIST', cache_list)

    // console.log('outer obj', { data: outer_data, props: outer_props });

    return { data: outer_data, props: outer_props }
  },
  // 更新或者添加某一个页面的 缓存数据
  updateCacheData ({ commit, state }, { pageName, props, target }) {
    const cur_store_data = storeData(props, target)

    const cache_data_list = state.cache_data_list

    // const cache_often_list = state.cache_often_list;

    if (cache_data_list.has(pageName)) {
      cache_data_list.set(pageName, { data: cur_store_data, props })
      // cache_often_list.props = props;
    }

    commit('SET_CACHE_DATA_LIST', cache_data_list)
    // commit('SET_CACHE_OFTEN_LIST', cache_often_list);
  },

  // 清除所有缓存数据
  clearCache ({ commit }) {
    commit('RESET_ALL_LIST')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
